export default "__VITE_ASSET__B6mfocu7__"